'use client';

import React from 'react';
// import Image from '@/lib/app-image';
import { Clock, FileDown } from 'lucide-react';
import { Button } from '../ui/button';
// import Link from '@/lib/app-link';
import { format } from 'date-fns';
import { useRouter } from '@/lib/navigation';
import { useDispatch } from 'react-redux';
import { setStateData } from '@flysync/shared-redux/slices/userSlice';

interface BookingListProps {
  data: {
    booking_code: string;
    origin_city: string;
    destination_city: string;
    departure_time: string;
    departure_date: Date;
    orgin_airport: string;
    orgin_terminal: string;
    duration: string;
    origin: string;
    destination: string;
    arrival_time: string;
    arrival_date: Date;
    destination_airport: string;
    destination_terminal: string;
    booking_status: string;
    tripType: string;
    segments: Array<{
      origin: string;
      departure_time: string;
      departure_date: Date;
      orgin_airport: string;
      origin_city: string;
      origin_terminal: string;
      duration: string;
      destination: string;
      arrival_time: string;
      arrival_date: Date;
      destination_airport: string;
      destination_terminal: string;
      destination_city: string;
    }>;
  };
  status: string;
  className?: string;
}

const BookingList: React.FC<BookingListProps> = ({ data, status, className }) => {
  const router = useRouter();
  const dispatch = useDispatch();
  const handleViewBooking = () => {
    dispatch(setStateData(data));
    router.push('/viewBooking');
  };

  const statusData: { [key: string]: string } = {
    CNL: 'Cancelled',
    CNF: 'Confirmed',
    PN: 'Pending',
    IP: 'In Progress',
    FD: 'Failed',
  };

  const statusColor: { [key: string]: string } = {
    CNL: 'text-red-500',
    CNF: 'text-green-500',
    PN: 'text-yellow-500',
    IP: 'text-red-500',
    FD: 'text-red-500',
  };

  return (
    <>
      {!data || Object.keys(data).length === 0 ? (
        <div className="flex flex-col items-center justify-center p-4 sm:p-6 lg:p-8">
          <div className="mb-3 sm:mb-4 text-2xl sm:text-4xl lg:text-5xl">
            🔍
          </div>
          <h3 className="mb-1.5 sm:mb-2 text-lg sm:text-xl font-semibold text-gray-800 text-center">
            No Bookings Found
          </h3>
          <p className="text-center text-sm sm:text-base text-gray-600 max-w-[250px] sm:max-w-none">
            We couldn't find any bookings.
          </p>
        </div>
      ) : (
          <div className={`sm:mx-3 lg:mx-4 my-2 sm:my-2 md:my-3 lg:my-4 rounded-xl sm:rounded-2xl lg:rounded-3xl border-2 border border-light ${className}`}>
            <div className="flex flex-col sm:flex-row sm:items-center justify-between border-b-2 border-light p-3 sm:p-4 lg:p-6 gap-2 sm:gap-0">
              <div className="text-xs sm:text-sm font-semibold leading-6 sm:leading-8 text-zinc-800">
              <div>Booking Id: {data?.booking_code}</div>
                <div className="text-base sm:text-lg">
                  {data?.origin_city} - {data?.destination_city} {data?.tripType === 'RT' && (<span> - {data?.origin_city}</span>)}
              </div>
                <div className={`text-sm ${status === 'CNF' ? 'text-green-500' : statusColor[data?.booking_status]}`}>
                {status || statusData[data?.booking_status]}
              </div>
            </div>
            <div>
              <Button
                  className="text-xs sm:text-sm text-white w-full sm:w-auto px-3 sm:px-4 py-1.5 sm:py-2"
                onClick={handleViewBooking}
              >
                View Booking
              </Button>
            </div>
          </div>
            {data?.segments.map((segment, i) => (
              <div key={i} className="flex flex-col sm:flex-row items-start sm:items-center justify-between p-3 sm:p-4 lg:p-6 gap-4 sm:gap-2">
                <div>
                <h2 className="text-base sm:text-lg font-bold text-zinc-800">
                    {segment?.origin}{' '}
                    {segment?.departure_time
                      ? format(
                      new Date(`1970-01-01T${segment?.departure_time}`),
                      'HH:mm',
                    )
                      : ''}
                  </h2>
                <div className="w-full sm:w-52 text-xs sm:text-sm text-zinc-800">
                    {format(segment?.departure_date, 'EEE dd MMM yyyy')}{' '}
                    {segment?.orgin_airport}, {segment?.origin_city},
                    <span className="text-[10px] sm:text-xs text-zinc-800">
                      {segment?.origin_terminal}
                    </span>
                  </div>
                </div>
              <div className="text-center self-center">
                <div className="flex items-center p-1 sm:p-2">
                  <span className="rounded-full border border-gray-400 p-0.5 sm:p-1"></span>
                  <span className="relative w-16 sm:w-20 lg:w-24 border border-dotted border-gray-400">
                    <Clock className="absolute -top-2 sm:-top-3 left-6 sm:left-7 lg:left-9 h-4 w-4 sm:h-5 sm:w-5 lg:h-6 lg:w-6 rounded-full bg-white text-orange-400" />
                    </span>
                  <span className="rounded-full border border-gray-400 p-0.5 sm:p-1"></span>
                  </div>
                  <div className="text-xs sm:text-sm">{segment?.duration}</div>
                </div>
                <div>
                <h2 className="text-base sm:text-lg font-bold text-zinc-800">
                    {segment?.destination}{' '}
                    {segment?.arrival_time
                      ? format(
                      new Date(`1970-01-01T${segment?.arrival_time}`),
                      'HH:mm',
                    )
                      : ''}
                  </h2>
                <div className="w-full sm:w-52 text-xs sm:text-sm text-zinc-800">
                    {segment?.arrival_date && segment.arrival_date.toString() !== '0000-00-00'
                      ? format(new Date(segment.arrival_date), 'EEE dd MMM yyyy')
                      : 'Invalid date'}{' '}
                    {segment?.destination_airport}, {segment?.destination_city},
                    <span className="text-[10px] sm:text-xs text-zinc-800">
                      {segment?.destination_terminal}
                    </span>
                  </div>
                </div>
                {/* <div className="flex cursor-pointer items-center text-xs text-red-400 hover:underline">
          <FileDown className="h-4 w-4" />
          Download Invoice
        </div> */}
              </div>
            ))}
        </div>
      )}
    </>
  );
};

export default BookingList;
